import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AboOverviewComponent } from '@components/abo-admin';
import { AdminViewHeaderComponent } from '@components/abo-admin/admin-view-header/admin-view-header.component';
import { TranslocoService } from '@ngneat/transloco';
import { AuthenticationService } from '@utils/AuthenticationService';

@Component({
  selector: 'rpt-admin-view',
  standalone: true,
  imports: [AsyncPipe, AboOverviewComponent, AdminViewHeaderComponent],
  templateUrl: './admin-view.component.html',
  styleUrl: './admin-view.component.scss'
})
export class AdminViewComponent {
  protected readonly authService: AuthenticationService = inject(AuthenticationService);
  protected readonly translocoService: TranslocoService = inject(TranslocoService);
}
